import React from "react";
import "../../App.css";

import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";

const Footer = () => {
  return (
    <>
      <div className="footer">
        <div
          style={{
            textAlign: "right",
            display: "inline-block",
            width: "5%",
          }}
        ></div>
        <div
          style={{
            textAlign: "left",
            display: "inline-block",
            width: "15%",
          }}
        >
          <p style={{ fontSize: "18px" }}>info@millyfanzaga.com</p>
          <p style={{ fontSize: "18px" }}>Tel. +39 393 26 89 311</p>
        </div>
        <div
          style={{
            textAlign: "left",
            display: "inline-block",
            width: "10%",
          }}
        >
          <a
            href={"https://www.instagram.com/fanzagam/"}
            style={{ textDecoration: "none", color: "white" }}
          >
            <p
              style={{
                fontSize: "18px",
              }}
            >
              <InstagramIcon
                style={{ verticalAlign: "middle", marginRight: "2px" }}
              />{" "}
              fanzagam
            </p>
          </a>
          <a
            href={"https://www.facebook.com/milly.fanzaga"}
            style={{ textDecoration: "none", color: "white" }}
          >
            <p style={{ fontSize: "18px" }}>
              <FacebookIcon
                style={{ verticalAlign: "middle", marginRight: "2px" }}
              />{" "}
              Milly Fanzaga
            </p>
          </a>
        </div>
        <div
          style={{
            textAlign: "left",
            display: "inline-block",
            width: "34%",
          }}
        ></div>
        <div
          style={{
            textAlign: "left",
            display: "inline-block",
            width: "25%",
          }}
        ></div>
        <div
          style={{
            textAlign: "right",
            display: "inline-block",
            width: "10%",
          }}
        >
          <p style={{ fontSize: "16px" }}>
            {" "}
            &copy; {new Date().getFullYear()} Milly Fanzaga
          </p>
        </div>
        <div
          style={{
            textAlign: "right",
            display: "inline-block",
            width: "1%",
          }}
        ></div>
      </div>
    </>
  );
};

export default Footer;
